"use client";

import { Icon, lazyHydrate, ospThemes } from "@ospweb/sdk-ui";
import { AppImage } from "@/src/components/NextImage";

import { Drawer } from "antd";
import type { FC } from "react";
import { useParams } from "next/navigation";

const MenuContentHydrated = lazyHydrate(
  () => import("./MenuContent").then((mod) => mod.MenuContent),
  {
    idleOptions: {
      enableIdleCallback: true,
    },
    loading: () => <div className="w-full h-full bg-transparent"></div>,
  },
);
interface MenuModalProps {
  isOpen: boolean;
  onCancel: () => void;
  placement?: "left" | "right";
}

export const MenuModal: FC<MenuModalProps> = ({
  isOpen,
  onCancel,
  placement = "right",
}) => {
  const { locale = "en" } = useParams() as { locale: string };
  return (
    <Drawer
      open={isOpen}
      onClose={onCancel}
      footer={false}
      width="280px"
      className="!bg-background_solid_secondary"
      closeIcon={false}
      placement={placement}
      zIndex={999}
      styles={{
        body: {
          padding: "0",
        },
      }}
    >
      <div className="h-full flex flex-col justify-between py-safe">
        <div className="flex justify-between items-center px-3 mt-3">
          <picture>
            <source
              srcSet="/assets/images/edgen.webp"
              type="image/webp"
              media="(min-width: 960px)"
            />
            <AppImage
              width={45.16}
              height={24}
              alt="edgen-logo"
              className="block h-6 w-[45.16px] opacity-100 transition-opacity group-hover:hidden"
              src="/assets/images/edgen-light.webp"
            />
          </picture>
          <Icon
            data-openreplay-label="close"
            name="close"
            size={20}
            color={ospThemes.colors.content_quaternary}
            className="cursor-pointer"
            onClick={onCancel}
          />
        </div>
        <MenuContentHydrated
          forceHydrate={isOpen}
          isShowLogo={false}
          onCancel={onCancel}
          className="mt-3"
          locale={locale}
        />
      </div>
    </Drawer>
  );
};
